import { postAsJson, fetchAsJson } from '@eig-builder/core-utils/helpers/fetch-helper'
import { getRuntimeConfig } from '@eig-builder/core-utils/helpers/runtime-config-helper'
import { getUrl, siteNames } from '@eig-builder/core-utils/helpers/url-helper'
import { GET_REFRESH_TOKEN, GET_TOKEN_VALIDATE } from './action-types'

let timeoutToRefeshAuthToken = null
const refreshTime = 5 * 60 * 1000

export const getTokenValidate = () => {
  const fetchAuthenticationSiteName = getRuntimeConfig()._fetchAuthenticationSiteName || siteNames.API_CRM

  return async function (dispatch, getState) {
    if (timeoutToRefeshAuthToken) {
      window.clearTimeout(timeoutToRefeshAuthToken)
    }

    timeoutToRefeshAuthToken = window.setInterval(async function () {
      const state = getState()
      if (state.auth.isAuthenticated) {
        const tokenRefresh = postAsJson(getUrl(fetchAuthenticationSiteName, '/v1.0/token/refresh'), undefined, {
          key: GET_REFRESH_TOKEN,
          dontShowErrorsInNotificationBar: true,
          doNotRedirectToLoginOn401: true,
          convertToCamelCase: true
        })(dispatch, getState)

        await tokenRefresh
      }
    }, refreshTime)

    return fetchAsJson(getUrl(fetchAuthenticationSiteName, '/v1.0/token/me'), {
      key: GET_TOKEN_VALIDATE,
      dontShowErrorsInNotificationBar: true,
      doNotRedirectToLoginOn401: true,
      convertToCamelCase: true
    })(dispatch, getState)
  }
}
